import { initialUsersState, actions } from "./action";

export const usersReducer = (state = initialUsersState, action) => {
    switch (action.type) {
        case actions.USERS_GET_ALL_SUCCESS:
            return {
                ...state,
                userList:  action.payload ? action.payload : {}
            };
        case actions.USERS_UPDATE_SUCCESS:
            return {
                ...state,
                userDetails: action.payload?.id ? {...action.payload, action: 'update'} : {}
            };
        case actions.USERS_CREATE_SUCCESS:
            return {
                ...state,
                userDetails: action.payload?.id ? {...action.payload, action: 'create'} : {}
            };
        case actions.USERS_DELETE_SUCCESS:
            return {
                ...state,
                userDetails: action.payload?.id ? {...action.payload, action: 'delete'} : {}
            };
        case actions.USERS_RESET_SUCCESS:
            return {
                ...state,
                userDetails: {}
            };
        default:
            return state;
    }
};
